import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import 'react-phone-number-input/style.css'
import { validFiles, validImage } from '../../utils/validators';
import galary from '../../assets/images/element/gallery.svg'
import Alert from '../../components/Alert/Alert';
import { selectUserRequestsData, useCreateRequestMutation } from '../../redux/apiSlices/requestSlice';


function OrganizationCreateRequest() {

  const data = useSelector(selectUserRequestsData)

  const navigate = useNavigate();


  const [createRequest, {isLoading}  ] = useCreateRequestMutation();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [filesErrorMsg, setFilesErrorMsg] = useState('');
  const [files, setFiles] = useState(null);


  const handleTitle = (event) => {
    setTitle(event.target.value);
  }

  

  

 

  

  const handleContent = (event) => {
    setContent(event.target.value);
  }

  const handleUploadfiles = (e) => {
    if(e.target.files.length) {
        if (validFiles(e.target.files)) {
            console.log('valid files xxxxxxxx')
            if (filesErrorMsg) {
                setFilesErrorMsg('')
            }
            setFiles(e.target.files);
        } else {
            setFilesErrorMsg('not soported file extention')
            setFiles(null);
        }
    }

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(files)
    // let formData = new FormData()
    
    if (!filesErrorMsg){
      let formData = new FormData();
      formData.append('title', title);
      formData.append('content', content);
      for (let i = 0; i < files?.length; i++) {
        formData.append("attachments", files[i], files[i].name)
        console.log('index', i)
      }
      try {
        await createRequest(formData).unwrap()
        navigate('/successful-page/generl')

      } catch (err) {
          console.error('Failed to save the changes', err)
      }
   }

  };
  return (
    <div class="col-xl-9">
      <div class="card bg-transparent border rounded-3">
          {/* <!-- Card header --> */}
          <div class="card-header bg-transparent border-bottom">
            <h3 class="card-header-title mb-0">تقديم عريضة</h3>
          </div>
          {/* <!-- Card body START --> */}

          {data?.verification_status === "unverified" ?
           <div class='my-3'> <Alert type='error' text='يرجى تقديم طلب توثيق الحساب حتى يتسنى لك تقديم العريضة' /> </div>
            : 
           data?.verification_status === "pending" ? 
           <div class='my-3'> <Alert type='error' text='سيتسنى لك تقديم العريضة بعد أن يتم توثيق حسابك' /> </div>
           : 
           data?.approved_soon ?
           <div class='my-3'> <Alert type='error' text='لقد قمت بالتقديم مسبقا وتمت الموافقة على طلبك, يرجى التقديم بعد عام أو أكثر من آخر موافقة, شكرا لتفهمكم' /> </div>
            :
          
          <div class="card-body">
          {/* <!-- Form --> */}
            <form class="row g-4">

                

                {/* <!-- Full name --> */}
                <div class="col-lg-6">
                <label class="form-label">عنوان العريضة</label>
                    <input 
                    type="text" 
                    class="form-control" 
                    value={title} 
                    onChange={handleTitle}
                    placeholder="عنوان العريضة"
                    />
                    </div>

                

               {/* <!-- About me --> */}
               <div class="col-12">
                <label class="form-label">محتوى العريضة</label>
                <textarea
                    class="form-control" 
                    rows="10"
                    placeholder="محتوى العريضة"
                    value={content}
                    onChange={handleContent}
                    />
                </div>

                {/* <!-- Upload image START --> */}
            <div class="col-12">
                <div class="text-center justify-content-center align-items-center p-3 p-sm-3 border border-2 border-dashed position-relative rounded-3">
                    {/* <!-- Image --> */}
                    {filesErrorMsg ? <div class='my-3'> <Alert type='error' text= {filesErrorMsg} /> </div>: <img src={galary} class="h-50px" alt=""/>}
                    <div>
                        <h6 class="my-2">ارفع المرفقات هنا, أو<a href="#!" class="text-primary"> اختر من جهازك</a></h6>
                        <label style={{"cursor":"pointer"}}>
                            <span> 
                                <input 
                                  onChange={handleUploadfiles} 
                                  class="form-control stretched-link" 
                                  type="file" 
                                  name="my-files" 
                                  id="files" 
                                  accept="image/gif, image/jpeg, image/png, application/pdf"
                                  multiple 
                                  />
                            </span>
                        </label>
                            <p class="small mb-0 mt-2"><b>ملاحظة:</b> صيغة المرفقات المقبولة JPG, JPEG, PNG and PDF.</p>
                    </div>	
                </div>

                {/* <!-- Button --> */}
                <div class="d-sm-flex justify-content-end mt-2">
                    <button onClick={()=> setFiles(null)} type="button" class="btn btn-sm btn-danger-soft mb-3">إزالة المرفقات</button>
                </div>
            </div>
            {/* <!-- Upload image END --> */}


                


                {/* <!-- Save button --> */}
                
                <div class="d-flex justify-content-end mt-4">
                    {isLoading ?
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        يتم التحميل...
                    </button> 
                    :
                    <button onClick={handleSubmit} class="btn btn-primary mb-0">تأكيد الطلب</button>
                    }
                </div>



                

                <div class='row'>
                
                
                </div>


            </form>
          </div>
          }
          {/* <!-- Card body END --> */}
        </div>
	  </div>
  )
}

export default OrganizationCreateRequest